export const Frequency = {
  OnceOff: 'OnceOff',
  Monthly: 'Monthly',
} as const;

export type FrequencyValue = (typeof Frequency)[keyof typeof Frequency];

export interface IFrequency {
  id: number;
  name: string;
  code: string;
}
